import { useQuery } from "@tanstack/react-query";
import subscriptionApi from "../api/subscription.js";

const useSubscription = () => {
    return useQuery({
        queryKey: ["my-subscription"],
        queryFn: async () => {
          const res = await subscriptionApi.getMySubscription();
          return res.data;
        },
        staleTime: 5 * 60 * 1000,
      });
}

export default useSubscription;